export default "__VITE_ASSET__6f798530__"